var UTILS = require("../libs/utils.js");
var config = require("../config.js");
const badges = [{
  name: "Legacy Challenger",
  id: 0,
  desc: "Completed Old Challenge Lvl 30"
}, {
  name: "Skin Creator I",
  id: 1,
  desc: "50 skins added to the game"
}, {
  name: "Skin Creator II",
  id: 1,
  tex: 1,
  desc: "100 skins added to the game"
}, {
  name: "Skin Creator III",
  id: 1,
  tex: 2,
  desc: "200 skins added to the game"
}, {
  name: "Skin Creator IV",
  id: 1,
  tex: 3,
  desc: "300 skins added to the game"
}, {
  name: "Deputy",
  id: 2,
  desc: ""
}, {
  name: "Officer",
  id: 2,
  tex: 1,
  desc: ""
}, {
  name: "Sergeant",
  id: 2,
  tex: 2,
  desc: ""
}, {
  name: "Lieutenant",
  id: 2,
  tex: 3,
  desc: ""
}, {
  name: "Captain",
  id: 2,
  tex: 4,
  desc: ""
}, {
  name: "Major",
  id: 2,
  tex: 5,
  desc: ""
}, {
  name: "Nuclear I",
  id: 3,
  desc: "Call in 500 Nukes",
  claimable: true,
  req: function (account) {
    return account && account.stats && (account.stats.n || 0) >= 500;
  }
}, {
  name: "Translators",
  id: 7,
  desc: "Contributors of the Translation Project"
}, {
  name: "Nuclear II",
  id: 3,
  tex: 1,
  desc: "Call in 750 Nukes",
  claimable: true,
  req: function (account) {
    return account && account.stats && (account.stats.n || 0) >= 750;
  }
}, {
  name: "Nuclear III",
  id: 3,
  tex: 2,
  desc: "Call in 1000 Nukes",
  claimable: true,
  req: function (account) {
    return account && account.stats && (account.stats.n || 0) >= 1000;
  }
}, {
  name: "Nuclear IV",
  id: 3,
  tex: 3,
  desc: "Call in 1500 Nukes",
  claimable: true,
  req: function (account) {
    return account && account.stats && (account.stats.n || 0) >= 1500;
  }
}, {
  name: "Gratitude I",
  id: 8,
  desc: "Contributing to the development of krunker"
}, {
  name: "Gratitude II",
  id: 8,
  tex: 1,
  desc: "Contributing to the development of krunker"
}, {
  name: "Gratitude III",
  id: 8,
  tex: 2,
  desc: "Contributing to the development of krunker"
}, {
  name: "Map Maker I",
  id: 9,
  desc: ""
}, {
  name: "Map Maker II",
  id: 9,
  tex: 1,
  desc: ""
}, {
  name: "Map Maker III",
  id: 9,
  tex: 2,
  desc: ""
}, {
  name: "Season 6 Founder",
  id: 10,
  desc: "Purchase the Battle Pass in the first week",
  endDate: "December 1, 2022 12:00 AM UTC",
  founder: true,
  season: 6,
  claimable: true,
  req: function (account) {
    if (account) {
      var v9871 = new Date(this.endDate).getTime();
      return config.currentSeason == 6 && account && account.BP && account.BP.tier && Date.now() < v9871;
    }
  }
}, {
  name: "S6 Map Master",
  id: 12,
  desc: "Collect all Season 6 map rewards",
  claimable: true,
  req: function (account) {
    if (!account || account && !account.skins) {
      return false;
    }
    for (var vA547 = [5237, 5238, 5239, 5240, 5241, 5242, 5243, 5244, 5245, 5246, 5247, 5248, 5249, 5250, 5251, 5252, 5253], vLN01584 = 0, vLN01585 = 0; vLN01585 < vA547.length; vLN01585++) {
      if (account.hasSkin(vA547[vLN01585])) {
        vLN01584++;
      }
    }
    return config.currentSeason == 6 && vLN01584 >= vA547.length;
  }
}, {
  name: "S6 Battle Pass Master",
  id: 14,
  desc: "Complete the Battle Pass in Season 6",
  claimable: true,
  req: function (account) {
    return config.currentSeason == 6 && account && account.BP && account.BP.tier && account.BP.bpp >= 15000;
  }
}, {
  name: "S6 Badge Master",
  id: 13,
  desc: "Obtain all Season 6 badges",
  claimable: true,
  req: function (account) {
    return config.currentSeason == 6 && account && account.badges && account.badges.includes(22) && account.badges.includes(23) && account.badges.includes(24);
  }
}, {
  name: "Season 7 Founder",
  id: 15,
  desc: "Purchase the Battle Pass in the first week",
  endDate: "April 11, 2023 12:00 AM UTC",
  founder: true,
  season: 7,
  claimable: true,
  req: function (account) {
    if (account) {
      var v9872 = new Date(this.endDate).getTime();
      return config.currentSeason == 7 && account && account.BP && account.BP.tier && Date.now() < v9872;
    }
  }
}, {
  name: "S7 Battle Pass Master",
  id: 16,
  desc: "Complete the Battle Pass in Season 7",
  claimable: true,
  req: function (account) {
    return config.currentSeason == 7 && account && account.BP && account.BP.tier && account.BP.bpp >= 15000;
  }
}, {
  name: "S7 Badge Master",
  id: 17,
  desc: "Obtain all Season 7 badges",
  claimable: true,
  req: function (account) {
    return config.currentSeason == 7 && account && account.badges && account.badges.includes(26) && account.badges.includes(27);
  }
}];
for (var i = 0; i < badges.length; i++) {
  badges[i].index = i;
  badges[i].url = UTILS.assetsUrl("textures/badges/badge_" + badges[i].id + (badges[i].tex ? "_" + badges[i].tex : "") + ".png", undefined, !!badges[i].local);
}
module.exports = badges;